export default {
  default: () => import("/opt/atlassian/pipelines/agent/build/layouts/default.vue").then(m => m.default || m)
}